import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

class PopLivecam extends Component {
  render() {
    const { largeFeedHtml, title } = this.props;
    return (
      <iframe
        style={{ height: '100%', width: '100%' }}
        id="primary-feed"
        className="embed-responsive-item"
        src={largeFeedHtml}
        frameBorder="0"
        allowFullScreen
        is
        allow="autoplay; encrypted-media"
        title={title}
      />
    );
  }
}

PopLivecam.propTypes = {
  title: PropTypes.string.isRequired,
  largeFeedHtml: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => {
  return {
    title: state.currentItem.data.title,
    largeFeedHtml: state.currentItem.data.large_feed_html,
  };
};

export default connect(mapStateToProps)(PopLivecam);
